
import React from 'react';
import Contact from './Contact';
import Home from './Home';
import Product1 from './Product1';
import About from './About';

const PageHeader = () => {
    
    const navItems = [{id:"first", title: "Home", child: <Home />},
                        {id:"second", title: "Product", child: <Product1 />},
                        {id:"third", title: "About", child: <About />},
                        {id:"fourth", title: "Contact", child: <Contact />}]
    
    const handleTabItemClick = (e) => {
        navItems.map(item =>{
            document.getElementById(`${item.id}`).classList.remove("active");
            document.getElementById(`${item.id}-sub`).classList.remove("active");
        })
        document.getElementById(`${e.target.id}`).classList.add("active");
        document.getElementById(`${e.target.id}-sub`).classList.add("active");
    }

let newJsx;
newJsx = ( <div id="navbar-container">
                <div id="navbar-header" className="ui secondary menu">
                    {navItems.map(item =>(
                        <a id={item.id} className={item.id === "first"? "item active" : "item"} data-tab={item.id} onClick={handleTabItemClick}>{item.title}</a>
                    ))}
                </div>
                <div id="body-content">
                    {navItems.map(item =>(
                        <div id={item.id+"-sub"} className={item.id === "first"? "ui tab segment tabBody active" : "ui tab segment tabBody"} data-tab={item.id}>
                            {item.child}
                        </div>
                    ))}
                </div>
            </div>)
    
    return (<div>{newJsx}</div>)
}
export default PageHeader;
